import { RiderApplicationDashboardState } from './RiderApplicationDashboard.types';
import {
  RIDER_APP_DASHBOARD_FETCH_METADATA,
  RIDER_APP_DASHBOARD_FETCH_METADATA_LOADING,
  RIDER_APP_DASHBOARD_FETCH_METADATA_ERROR,
  RIDER_APP_DASHBOARD_FETCH_APPLICATIONS,
  RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_LOADING,
  RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_ERROR,
  RIDER_APP_DASHBOARD_SET_ACTIVE_TAB,
  RIDER_APP_DASHBOARD_SET_APPLIED_FILTERS,
  RIDER_APP_DASHBOARD_SET_SORT,
  RIDER_APP_DASHBOARD_SET_PAGINATION,
  RIDER_APP_DASHBOARD_FETCH_DETAIL,
  RIDER_APP_DASHBOARD_FETCH_DETAIL_LOADING,
  RIDER_APP_DASHBOARD_FETCH_DETAIL_ERROR,
  RIDER_APP_DASHBOARD_CLEAR_DETAIL,
  RIDER_APP_DASHBOARD_APPROVE,
  RIDER_APP_DASHBOARD_APPROVE_ERROR,
  RIDER_APP_DASHBOARD_REJECT,
  RIDER_APP_DASHBOARD_REJECT_ERROR,
  RIDER_APP_DASHBOARD_RETURN,
  RIDER_APP_DASHBOARD_RETURN_ERROR,
  RIDER_APP_DASHBOARD_DISABLE,
  RIDER_APP_DASHBOARD_DISABLE_ERROR,
  RIDER_APP_DASHBOARD_EDIT_FORM,
  RIDER_APP_DASHBOARD_EDIT_FORM_ERROR,
  RIDER_APP_DASHBOARD_EXPORT,
  RIDER_APP_DASHBOARD_EXPORT_LOADING,
  RIDER_APP_DASHBOARD_EXPORT_ERROR,
  RIDER_APP_DASHBOARD_FETCH_BUCKET_COUNTS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_SORT,
  RIDER_APPLICATION_METADATA,
} from './RiderApplicationDashboard.constants';

const defaultState: RiderApplicationDashboardState = {
  applications: [],
  metadata: RIDER_APPLICATION_METADATA,
  isLoading: false,
  isMetadataLoading: false,
  isExportLoading: false,
  errorMessage: null,
  activeTab: 'all_applications',
  appliedFilters: {},
  sort: DEFAULT_SORT,
  pagination: {
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalCount: 0,
  },
  cityOptions: [],
  hubOptions: [],
  stageOptions: [],
  selectedApplication: null,
  isDetailLoading: false,
  bucketCounts: {},
};

export default function riderApplicationDashboardReducer(
  state = defaultState,
  action: { type: string; data?: unknown },
): RiderApplicationDashboardState {
  switch (action.type) {
    case RIDER_APP_DASHBOARD_FETCH_METADATA:
      return {
        ...state,
        metadata: action.data as RiderApplicationDashboardState['metadata'],
        errorMessage: null,
      };

    case RIDER_APP_DASHBOARD_FETCH_METADATA_LOADING:
      return {
        ...state,
        isMetadataLoading: action.data as boolean,
      };

    case RIDER_APP_DASHBOARD_FETCH_METADATA_ERROR:
      return {
        ...state,
        errorMessage: (action.data as string) || null,
      };

    case RIDER_APP_DASHBOARD_FETCH_APPLICATIONS: {
      const payload = action.data as {
        results: RiderApplicationDashboardState['applications'];
        totalCount: number;
        page: number;
        pageSize: number;
      };
      return {
        ...state,
        applications: payload.results,
        pagination: {
          ...state.pagination,
          totalCount: payload.totalCount,
          currentPage: payload.page,
          pageSize: payload.pageSize,
        },
        errorMessage: null,
      };
    }

    case RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_LOADING:
      return {
        ...state,
        isLoading: action.data as boolean,
      };

    case RIDER_APP_DASHBOARD_FETCH_APPLICATIONS_ERROR:
      return {
        ...state,
        errorMessage: (action.data as string) || null,
      };

    case RIDER_APP_DASHBOARD_FETCH_BUCKET_COUNTS:
      return {
        ...state,
        bucketCounts: (action.data as RiderApplicationDashboardState['bucketCounts']) || {},
      };

    case RIDER_APP_DASHBOARD_SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.data as RiderApplicationDashboardState['activeTab'],
        applications: [],
        isLoading: true,
        errorMessage: null,
      };

    case RIDER_APP_DASHBOARD_SET_APPLIED_FILTERS:
      return {
        ...state,
        appliedFilters: action.data as RiderApplicationDashboardState['appliedFilters'],
      };

    case RIDER_APP_DASHBOARD_SET_SORT:
      return {
        ...state,
        sort: action.data as RiderApplicationDashboardState['sort'],
      };

    case RIDER_APP_DASHBOARD_SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...(action.data as Partial<RiderApplicationDashboardState['pagination']>),
        },
      };

    case RIDER_APP_DASHBOARD_FETCH_DETAIL:
      return {
        ...state,
        selectedApplication: action.data as RiderApplicationDashboardState['selectedApplication'],
        errorMessage: null,
      };

    case RIDER_APP_DASHBOARD_FETCH_DETAIL_LOADING:
      return {
        ...state,
        isDetailLoading: action.data as boolean,
      };

    case RIDER_APP_DASHBOARD_FETCH_DETAIL_ERROR:
      return {
        ...state,
        errorMessage: (action.data as string) || null,
      };

    case RIDER_APP_DASHBOARD_CLEAR_DETAIL:
      return {
        ...state,
        selectedApplication: null,
        isDetailLoading: false,
      };

    case RIDER_APP_DASHBOARD_APPROVE:
    case RIDER_APP_DASHBOARD_REJECT:
    case RIDER_APP_DASHBOARD_RETURN:
    case RIDER_APP_DASHBOARD_DISABLE:
    case RIDER_APP_DASHBOARD_EDIT_FORM:
      return {
        ...state,
        errorMessage: null,
      };

    case RIDER_APP_DASHBOARD_APPROVE_ERROR:
    case RIDER_APP_DASHBOARD_REJECT_ERROR:
    case RIDER_APP_DASHBOARD_RETURN_ERROR:
    case RIDER_APP_DASHBOARD_DISABLE_ERROR:
    case RIDER_APP_DASHBOARD_EDIT_FORM_ERROR:
      return {
        ...state,
        errorMessage: (action.data as string) || null,
      };

    case RIDER_APP_DASHBOARD_EXPORT:
      return {
        ...state,
        errorMessage: null,
      };

    case RIDER_APP_DASHBOARD_EXPORT_LOADING:
      return {
        ...state,
        isExportLoading: action.data as boolean,
      };

    case RIDER_APP_DASHBOARD_EXPORT_ERROR:
      return {
        ...state,
        errorMessage: (action.data as string) || null,
      };

    default:
      return state;
  }
}
